exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".axis path,\n.axis line {\n  fill: none;\n  stroke: #000;\n  shape-rendering: crispEdges; }\n\n.areaPath1 {\n  fill: #3bcbe380; }\n\n.areaPath2 {\n  fill: #5262ade8; }\n\n.areaPath3 {\n  fill: #8775a7; }\n\n.overlay {\n  fill: none !important;\n  pointer-events: all; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/multiAreaChart/AreaChartWithAxis/AreaChartWithAxis.scss
// module id = 1458
// module chunks = 0